<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      :loader="$store.state.spinerLoader"
      :color="$store.state.spinerColor"
    ></loading>
    <b-card>
      <b-row align-v="center" slot="header">
        <b-col cols="6">
          <h3 class="mb-0">All Client Claims</h3>
        </b-col>
        <b-col cols="2"> </b-col>
        <b-col cols="4">
          <div class="">
            <b-input-group>
              <b-form-input
                class="search-outline"
                placeholder="Search All Claims this client"
                v-model="globalClaimFilterStr"
              ></b-form-input>
              <b-input-group-append>
                <b-button
                  @click="clearGlobalClaimSearchString"
                  variant="outline-secondary"
                  ><i class="fa-solid fa-times"></i
                ></b-button>
                <b-button
                  @click="startGlobalClaimSearchString"
                  variant="outline-secondary"
                  ><i class="fa-solid fa-magnifying-glass"></i
                ></b-button>
              </b-input-group-append>
            </b-input-group>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <vuetable
            ref="vuetable"
            :api-mode="false"
            :fields="fields"
            :per-page="perPage"
            :data-manager="dataManager"
            pagination-path="pagination"
            @vuetable:pagination-data="onPaginationData"
          >
            <template slot="claim-type" scope="props">
              <span>{{ claimTypeStr(props.rowData) }}</span>
            </template>
            <template slot="fye" scope="props">
              <b-link @click="loadActiveClaim(props.rowData)"
                ><span class="custom-non-br-undeline">{{
                  claimFyeStr(props.rowData)
                }}</span></b-link
              >
            </template>
            <template slot="client-name" scope="props">
              <span>{{ client_name }}</span>
            </template>
          </vuetable>
        </b-col>
        <b-col cols="12">
          <div style="padding-top: 10px">
            <vuetable-pagination-info
              ref="paginationInfo"
            ></vuetable-pagination-info>
            <vuetable-pagination
              class="float-right"
              ref="pagination"
              @vuetable-pagination:change-page="onChangePage"
            ></vuetable-pagination>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "../Vuetable/VuetablePaginationBootstrap4";
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo.vue";
import AllClaimsDef from "./AllClaimsDef.js";
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import mixins from "./../../mixins/common.js";

export default {
  props: ["client_id", "claim_id"],
  mixins: [mixins],
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
  },
  data() {
    return {
      fields: AllClaimsDef,
      claimdata: [],
      perPage: 10,
      globalClaimFilterStr: "",
      isLoading: false,
      fullPage: true,
    };
  },
  computed: {
    ...mapState("user", ["user_name", "is_admin"]),
    tr_upadte_str: {
      get() {
        return this.$store.state.admin.tr_upadte_str;
      },
      set(val) {
        this.$store.state.admin.tr_upadte_str = val;
      },
    },
    cs_upadte_str: {
      get() {
        return this.$store.state.admin.cs_upadte_str;
      },
      set(val) {
        this.$store.state.admin.cs_upadte_str = val;
      },
    },
    client_name: {
      get() {
        return this.$store.state.client_name;
      },
      set(val) {
        this.$store.state.client_name = val;
      },
    },
    client: {
      get() {
        return this.$store.state.client;
      },
      set(val) {
        this.$store.state.client = val;
      },
    },
    claim: {
      get() {
        return this.$store.state.claim;
      },
      set(val) {
        this.$store.state.claim = val;
      },
    },
    activeClaim: {
      get() {
        return this.$store.state.activeClaim;
      },
      set(val) {
        this.$store.state.activeClaim = val;
      },
    },
    tb_step: {
      get() {
        return this.$store.state.tb_step;
      },
      set(val) {
        this.$store.state.tb_step = val;
      },
    },
  },
  mounted() {
    //clear snotofy
    this.clearSnotifyMessages();
    this.getAllClaimDetails();
  },
  watch: {
    claimdata(newVal, oldVal) {
      this.$refs.vuetable.refresh();
    },
    claim_id: function (newVal, oldVal) {
      if (this.claimdata) {
        let filtered = this.claimdata.filter((claim) => {
          return claim.id == this.claim_id;
        });
        if (filtered[0]) {
          // this.activeClaim = filtered[0];
          // if (this.activeClaim.claimStatus == 2) {
          //   filtered[0].claimStatus = 3;
          //   this.changeClaimStatusToWorkInProgress();
          // }
        }
      }
    },
    client_id: function (newVal, oldVal) {
      if (!this.client_id) {
        this.claimdata = [];
      } else {
        const userdata = {
          client_id: this.client,
        };
        this.getAllClientsClaims(userdata).then((data) => {
          if (data.data.errors) {
          } else {
            if (data.data) {
              this.claimdata = data.data;
              let filtered = this.claimdata.filter((claim) => {
                return claim.id == this.claim_id;
              });
            } else {
              this.claimdata = [];
            }
          }
        });
      }
    },
  },
  methods: {
    ...mapActions("admin", [
      "getAllClientsClaims",
      "setToInprogessClaim",
      "getClaimRecordById",
    ]),
    refreshClaimSpecificData() {
      let claimParams = {
        claim_id: this.claim_id,
      };
      if (this.claim_id) {
        this.getClaimRecordById(claimParams).then((data) => {
          if (data && data.data) {
            this.cs_upadte_str = this.updateByCsStr(
              data.data.csUpdateBy,
              data.data.csUpdatedOn
            );
            this.tr_upadte_str = this.updateByTrStr(
              data.data.trUpdateBy,
              data.data.trUpdatedOn
            );
          } else {
          }
          this.isLoading = false;
        });
      }
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    loadActiveClaim(rowData) {
      this.claim = rowData.id;
      this.tb_step = 0;
      this.$router.replace({
        name: "claimwizard",
        query: { claim_id: this.claim, client_id: this.client_id },
      });
    },
    changeClaimStatusToWorkInProgress() {
      if (this.checkIfClaimHasPermission(this.activeClaim)) {
        this.isLoading = true;
        let inprogressParams = {
          claim_id: this.claim_id,
        };
        this.setToInprogessClaim(inprogressParams).then((data) => {
          if (data.data.errors) {
          } else {
            this.refreshClaimSpecificData();
            this.activeClaim.claimStatus = 3;
          }
          this.isLoading = false;
        });
      } else {
        this.isLoading = false;
      }
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    getAllClaimDetails() {
      if (this.client_id) {
        const userdata = {
          client_id: this.client_id,
        };
        this.getAllClientsClaims(userdata).then((data) => {
          if (data.data.errors) {
          } else {
            if (data.data) {
              this.claimdata = data.data;
            } else {
              this.claimdata = [];
            }
          }
        });
      }
    },
    dataManager(sortOrder, pagination) {
      let local = this.claimdata;
      let vm = this;
      if (this.globalClaimFilterStr) {
        // the text should be case insensitive
        let txt = new RegExp(this.globalClaimFilterStr.trim(), "i");
        let dataFil = _.filter(local, function (item) {
          return (
            vm.ammendString(item.claimType).search(txt) >= 0 ||
            vm.getMonthNameFormValue(item.fiscalMonth).search(txt) >= 0 ||
            String(item.fiscalYear).search(txt) >= 0 ||
            vm.claimTypeValueStr(item).search(txt) >= 0
          );
        });
        local = dataFil;
      }

      // sortOrder can be empty, so we have to check for that as well
      if (sortOrder.length > 0) {
        local = _.orderBy(
          local,
          sortOrder[0].sortField,
          sortOrder[0].direction
        );
      }

      pagination = this.$refs.vuetable.makePagination(
        local.length,
        this.perPage
      );
      let from = pagination.from - 1;
        let to = from + this.perPage;
      return {
        pagination: pagination,
        data: _.slice(local, from, to),
      };
    },
    clearGlobalClaimSearchString() {
      this.globalClaimFilterStr = "";
      this.$refs.vuetable.refresh();
    },
    startGlobalClaimSearchString() {
      this.$refs.vuetable.refresh();
    },
  },
};
</script>

<style scoped>
.custom-non-br-undeline {
  border-bottom: 1px;
  border-bottom-style: solid;
}
</style>
